import { render, staticRenderFns } from "./areaTree.vue?vue&type=template&id=77246443&scoped=true&"
import script from "./areaTree.vue?vue&type=script&lang=js&"
export * from "./areaTree.vue?vue&type=script&lang=js&"
import style0 from "./areaTree.vue?vue&type=style&index=0&id=77246443&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77246443",
  null
  
)

export default component.exports